export const FILE_NAME_PREFIX = "EY_SF_";
export const FILE_NAME_PREFIX_SF = "EYSF_";
export const FILE_NAME_PREFIX_WP = "EYWP_";